import React from "react";
import { useTranslation } from "react-i18next";
import i18n, { LETTERS } from "./i18n";

export default function Alphabet() {
  const { t } = useTranslation();

  return (
    <>
      <h1 className="text-4xl md:text-6xl font-semibold mb-8">{t("title")}</h1>
      <h2 className="text-xl mb-4">{t("alphabet-title")}</h2>
      <dl className="w-80 sm:w-[32rem] grid grid-cols-2 sm:grid-cols-3 gap-2">
        {LETTERS.map((letter) => (
          <div
            key={letter}
            className="flex items-baseline gap-3 bg-slate-700 rounded-md py-2 px-3"
          >
            <dt className="text-2xl font-semibold w-6">{letter}</dt>
            <dd className="text-lg">{t(letter)}</dd>
          </div>
        ))}
      </dl>
      {/* Swedish has no note, and a missing key would fall back to English */}
      {i18n.language === "en" && (
        <p className="w-80 sm:w-[32rem] mt-4 text-gray-300">
          {t("alphabet-note")}
        </p>
      )}
    </>
  );
}
